module.exports = __webpack_public_path__ + "img/support.206d7797.svg";